
import { defineComponent } from 'vue';

import PrzLikes from '@/components/Blocks/Singles/Parts/SocialLikes/Component.vue';
import PrzMedia from '@/components/Social/Post/Media/Desktop.vue';
import PrzLoader from '@/components/Muffin/Loader.vue';
import PostCommon from './Common.vue';

export default defineComponent({
    components: {
        PrzLikes,
        PrzMedia,
        PrzLoader
    },
    extends: PostCommon
});
